import { Clock3 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import MotionHalo from '@/components/atoms/MotionHalo';
import MotionSparkles from '@/components/atoms/MotionSparkles';

export default function Preparing({ screen }: { screen: string }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-1 items-center px-4 py-8">
      <section
        data-gp-reveal
        className="relative isolate w-full space-y-4 rounded-card bg-white p-6 text-center shadow-glow"
      >
        <MotionSparkles />
        <span className="relative mx-auto grid size-16 place-items-center rounded-full bg-gp-pink-50 text-gp-pink-800">
          <MotionHalo />
          <Clock3
            data-gp-reveal="icon"
            className="size-10"
            aria-hidden="true"
          />
        </span>
        <p className="text-caption font-semibold text-gp-ink-600">
          {t(`screens:${screen}`)}
        </p>
        <h1 className="text-h1 font-semibold">{t('mvp.preparing.title')}</h1>
        <p className="text-body text-gp-ink-600">{t('mvp.preparing.body')}</p>
        <Button asChild block>
          <Link to="/chat">{t('brand.talkToHost')}</Link>
        </Button>
        <Button asChild block variant="outline">
          <Link to="/">{t('tabs.home')}</Link>
        </Button>
      </section>
    </div>
  );
}
